import { callZpayFunction } from '../../callZpayFunction';

// 이전화면으로 이동
export const back = () => {
  callZpayFunction('back')();
};
